import { z } from 'zod';
import { Prisma } from './generated/index.js';

export type CreateCGUDto = {
  localeId: string;
} & Omit<Prisma.CGUCreateInput, 'id' | 'version' | 'locale' | 'createdAt' | 'updatedAt'>;

export const cgusQueryDtoSchema = z.object({
  page: z.coerce.number().int().positive().default(1).optional(),
  limit: z.coerce.number().int().positive().max(100).default(10).optional(),
});

export type CGUsQueryDto = z.infer<typeof cgusQueryDtoSchema>;
